import { CHANGE_CART_DRAWER } from './types';

/**
 * Changes the cart drawer state
 * @param {Boolean} isDrawerOpen - Is the drawer open?
 * @returns {Object<type, payload>} - Redux object
 */
export default isDrawerOpen => ({
  type: CHANGE_CART_DRAWER,
  payload: {
    isDrawerOpen,
  },
});
